import React, { useState, useEffect} from 'react'

import {
    Button,
    Form,
    Input,
    message,
    Select
  } from 'antd';
  import axios from 'axios';
  import { SERVER_ADDRESS } from '../../../Config/Config';
  
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

  const { Option } = Select;

const Addsubcategory = () => {
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
       const fetchCategories = async () => {
          try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`); 
            setCategories(response.data); 
          } catch (error) {
            message.error("Failed to fetch categories");
            console.error(error);
          }
        };
        fetchCategories();
      }, []);

const onFinish = async (values) =>{
    try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/add-subcategory`,values);
        if (response.status === 200) {
            form.resetFields();
            message.success({content: "Subcategory added Sucessfully", duration:2})
          } else {
            message.error({content: "Subcategory not added", duration:2})
          }
    } catch (error) {
        message.error({content:'Internal server Error',duration:2})
    }
} 

  return (
    <div style={{
        marginTop:'5rem',
      }}>
        <div style={{
          fontSize:'2rem'
        }}>
          Fill Details
        </div>
      <Form
        form={form}
      style={{
        backgroundColor:'white',
        width:'60rem',
        marginTop:'2rem',
        padding:'3rem',
        justifySelf:'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius:'0.6rem'
      }}
      labelCol={{span: 4}}
      wrapperCol={{span:14,offset:1}}
      onFinish={onFinish}
  >   
        <Form.Item label="Sub-Category Name" name="sub_category_name"  rules={[{ required: true, message: 'Enter the category name' }]}><Input placeholder="Enter Sub-category"></Input></Form.Item>
        <Form.Item label="Search Key" name="sub_category_search_key"  rules={[{ required: true, message: 'Enter the category search key name' }]}><Input placeholder="Enter search key"></Input></Form.Item>
        <Form.Item label="Category" name="category_id" rules={[{required:true, message:'Select the category'}]}>
            <Select placeholder="Select a category">
                {categories.map((category)=>(
                    <Option key={category.category_id} value={category.category_id}>{category.category_name}</Option>
                ))}
            </Select></Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
  
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>  
      </Form></div>
  )
}

export default Addsubcategory